import React, { ReactElement } from 'react';
import './borrow.less';
import Layout from './Layout';

export default function CentredLayout(props: {
    children: JSX.Element | JSX.Element[];
    pageName: string;
}): ReactElement {
    const { children, pageName } = props;

    return (
        <Layout pageName={pageName}>
            <main className='centred-layout' role='main'>
                <div className='main-section'>
                    <div className='body'>
                        <div className='main-box'>
                            {children}
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
}

